import { render } from "./NoInternetScreen.vue?vue&type=template&id=4961a6f8"
import script from "./NoInternetScreen.vue?vue&type=script&lang=js"
export * from "./NoInternetScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__